import { compose } from 'recompose';

import PostsFilter from './PostsFilter';

const enhance = compose();

export default enhance(PostsFilter);
